module.exports = __webpack_public_path__ + "img/old-style-meter.359bc020.png";